// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56bcc1bb","453":"54bbc2c3","455":"5fddb779","977":"33cf0274"}[chunkId] + ".chunk.js";
};